import { render, staticRenderFns } from "./performance-recap-paper.vue?vue&type=template&id=63620a73"
import script from "./performance-recap-paper.vue?vue&type=script&lang=js"
export * from "./performance-recap-paper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports